import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Cookie } from "lucide-react";

const CAT_IMG = {
  Snacks: "https://images.unsplash.com/photo-1599490659213-e2b9527bd087?w=400&q=80",
  Fruit: "https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=400&q=80",
  Juice: "https://images.unsplash.com/photo-1600271886742-f049cd451bba?w=400&q=80",
  Water: "https://images.unsplash.com/photo-1560023907-5f339617ea30?w=400&q=80",
  Drinks: "https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?w=400&q=80",
  Treats: "https://images.unsplash.com/photo-1499636136210-6f4ee915583e?w=400&q=80",
};

export default function SnackShop() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);
  const cats = [...new Set(products.map((p) => p.category))];

  return (
    <div>
      <h1 className="font-display font-extrabold text-2xl text-navy flex items-center gap-2"><Cookie className="w-6 h-6 text-coral" /> Snack Shop</h1>
      <p className="text-slate-500">Preview the menu — pay cashless with the Adventure Wallet.</p>
      <div className="mt-6 space-y-8">
        {cats.map((cat) => (
          <div key={cat} data-testid={`snack-cat-${cat}`}>
            <p className="font-display font-bold text-navy mb-3">{cat}</p>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
              {products.filter((p) => p.category === cat).map((p) => (
                <div key={p.id} className="bg-white rounded-2xl border border-slate-200 overflow-hidden" data-testid={`snack-item-${p.id}`}>
                  <div className="aspect-square bg-slate-100 overflow-hidden">
                    <img src={p.image || CAT_IMG[cat] || CAT_IMG.Snacks} alt={p.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="p-3">
                    <p className="font-semibold text-navy text-sm">{p.name}</p>
                    <p className="text-turquoise font-bold">${p.price.toFixed(2)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
        {products.length === 0 && <p className="text-slate-400">Menu coming soon.</p>}
      </div>
    </div>
  );
}
